var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLev1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198 361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fae757;\n      }\n\n      .cls-2 {\n        fill: #4d3423;\n      }\n\n      .cls-3 {\n        fill: #015e59;\n      }\n\n      .cls-4 {\n        fill: #cc8f70;\n      }\n\n      .cls-5 {\n        fill: #414a4c;\n      }\n\n      .cls-6 {\n        fill: #eeb68c;\n      }\n\n      .cls-7 {\n        fill: #bfa776;\n      }\n\n      .cls-8 {\n        fill: #e6eef2;\n      }\n\n      .cls-9 {\n        fill: #fff;\n      }\n\n      .cls-10 {\n        fill: #cfb580;\n      }\n\n      .cls-11 {\n        fill: #eb986d;\n      }\n\n      .cls-12 {\n        fill: #edb58c;\n      }\n\n      .cls-13 {\n        fill: #6fe8dd;\n      }\n\n      .cls-14 {\n        fill: none;\n        stroke: #4eadad;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-15 {\n        fill: #65442e;\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.29,49.97h34.51c10.79,0,19.55,8.76,19.55,19.55v48.71c0,16.83-13.67,30.5-30.5,30.5h-12.62c-16.83,0-30.5-13.67-30.5-30.5v-48.71c0-10.79,8.76-19.55,19.55-19.55Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 102.5,
    cy: 320,
    rx: 65.5,
    ry: 27
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 124.04,
    cy: 230.77,
    r: 15.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 108.47,
    y: 212.53,
    width: 16.81,
    height: 18.24,
    transform: "translate(233.75 443.31) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 104.29,
    y: 140.6,
    width: 25.17,
    height: 54.27,
    rx: 12.58,
    ry: 12.58,
    transform: "translate(233.75 335.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M108.71,169.63h16.33c2.44,0,4.42,1.98,4.42,4.42v28.11c0,6.95-5.64,12.58-12.58,12.58h0c-6.95,0-12.58-5.64-12.58-12.58v-28.11c0-2.44,1.98-4.42,4.42-4.42Z",
    transform: "translate(233.75 384.37) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 96.46,
    y: 199.15,
    width: 27.06,
    height: 70.77,
    rx: 13.53,
    ry: 13.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M103.88,242.82h11.66c4.41,0,7.98,3.58,7.98,7.98v39.57c0,7.47-6.06,13.53-13.53,13.53h0c-7.47,0-13.53-6.06-13.53-13.53v-40.13c0-4.1,3.33-7.42,7.42-7.42Z",
    transform: "translate(219.98 546.72) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M96.46,292.97h23.41c4.15,0,7.51,3.37,7.51,7.51v4.66c0,2.21-1.79,4.01-4.01,4.01h-22.92c-2.21,0-4.01-1.79-4.01-4.01v-12.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M100.38,303.9h30.27c5.36,0,9.71,4.35,9.71,9.71h0c0,2.08-1.69,3.77-3.77,3.77h-36.2c-2.16,0-3.92-1.76-3.92-3.92v-5.64c0-2.16,1.76-3.92,3.92-3.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 73.06,
    y: 212.52,
    width: 27.06,
    height: 70.77,
    rx: 13.53,
    ry: 13.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M80.49,256.2h11.66c4.41,0,7.98,3.58,7.98,7.98v39.57c0,7.47-6.06,13.53-13.53,13.53h0c-7.47,0-13.53-6.06-13.53-13.53v-40.13c0-4.1,3.33-7.42,7.42-7.42Z",
    transform: "translate(173.19 573.47) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M73.06,306.35h23.65c4.02,0,7.28,3.26,7.28,7.28v4.9c0,2.21-1.79,4.01-4.01,4.01h-22.92c-2.21,0-4.01-1.79-4.01-4.01v-12.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M76.98,317.28h30.27c5.36,0,9.71,4.35,9.71,9.71h0c0,2.08-1.69,3.77-3.77,3.77h-36.2c-2.16,0-3.92-1.76-3.92-3.92v-5.64c0-2.16,1.76-3.92,3.92-3.92Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 100.12,
    y1: 221.61,
    x2: 100.12,
    y2: 306.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M76.99,146.75h41.72c10.03,0,18.17,8.14,18.17,18.17v60.7H58.82v-60.7c0-10.03,8.14-18.17,18.17-18.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M116.73,146.79c0,6.55-5.31,11.86-11.86,11.86h-7.03s-7.03,0-7.03,0c-6.55,0-11.86-5.31-11.86-11.86h0s37.77,0,37.77,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.58,99.4l-52.16-1.36c-6.48,0-11.78-5.3-11.78-11.78v-28.12c0-10.24,8.38-18.62,18.62-18.62l38.48,1.36c10.24,0,18.62,8.38,18.62,18.62v28.12c0,6.48-5.3,11.78-11.78,11.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 82.64,
    y: 128.92,
    width: 30.41,
    height: 20.91
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.29,49.97h34.51c10.79,0,19.55,8.76,19.55,19.55v48.71c0,16.83-13.67,30.5-30.5,30.5h-12.62c-16.83,0-30.5-13.67-30.5-30.5v-48.71c0-10.79,8.76-19.55,19.55-19.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.51,124.92h-9.2c-5.34,0-9.68,4.33-9.68,9.68v11.32c0,5.32-4.32,9.64-9.64,9.64h-19.1c-5.32,0-9.64-4.32-9.64-9.64v-11.32c0-5.34-4.33-9.68-9.68-9.68h-19.06v32.63l27.2.13v6.08h41.39v-6.08h17.41v-32.76Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 128.33,
    y: 83.56,
    width: 19.55,
    height: 27.38,
    rx: 9.77,
    ry: 9.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 134.84,
    y: 90.24,
    width: 11.17,
    height: 18.74,
    rx: 5.58,
    ry: 5.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 133.99,
    y: 87.28,
    width: 6.11,
    height: 11.14,
    rx: 3.05,
    ry: 3.05
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M139.47,129.34c-2.95,6.14-9.22,10.37-16.48,10.37s-13.53-4.23-16.47-10.37h32.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.42,127.83l-15.83.58c-.7.03-1.28-.52-1.3-1.21-.02-.6.38-1.12.95-1.27l15.34-3.93c1.58-.41,3.2.55,3.61,2.13s-.55,3.2-2.13,3.61c-.2.05-.42.08-.63.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.99,122l15.34,3.93c.67.17,1.08.86.91,1.53-.15.58-.69.97-1.27.95l-15.83-.58c-1.63-.06-2.91-1.43-2.85-3.07.06-1.63,1.43-2.91,3.07-2.85.21,0,.43.04.63.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M126.99,89.39c-.58-1.39-2.54-1.39-3.13,0-2.28,5.43-6.26,19.03-6.26,26.87,0,6.7,7.82,7.18,7.82,7.18,0,0,7.82-.48,7.82-7.18,0-7.85-3.98-21.45-6.26-26.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145.33,103.94h3.4v6.88c0,3.58-2.91,6.49-6.49,6.49h0c-1.48,0-2.68-1.2-2.68-2.68v-4.93c0-3.18,2.58-5.77,5.77-5.77Z",
    transform: "translate(288.3 221.26) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 74.26,
    cy: 100.37,
    r: 11.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67.72,
    y: 106.27,
    width: 3.96,
    height: 8.78,
    rx: 1.98,
    ry: 1.98
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 71.66,
    cy: 255.91,
    r: 15.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 70.42,
    y: 237.67,
    width: 16.81,
    height: 18.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 66.24,
    y: 165.74,
    width: 25.17,
    height: 54.27,
    rx: 12.58,
    ry: 12.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M78.82,194.77h0c6.95,0,12.58,5.64,12.58,12.58v28.11c0,2.44-1.98,4.42-4.42,4.42h-16.33c-2.44,0-4.42-1.98-4.42-4.42v-28.11c0-6.95,5.64-12.58,12.58-12.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.32,56.07h8.31v38.4c0,4.96-4.02,8.98-8.98,8.98h0c-4.96,0-8.98-4.02-8.98-8.98v-28.75c0-5.33,4.32-9.65,9.65-9.65Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 95.39,
    y: 83.56,
    width: 19.55,
    height: 27.38,
    rx: 9.77,
    ry: 9.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 101.9,
    y: 90.24,
    width: 11.17,
    height: 18.74,
    rx: 5.58,
    ry: 5.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 101.04,
    y: 87.28,
    width: 6.11,
    height: 11.14,
    rx: 3.05,
    ry: 3.05
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.85,43.24c0-5.6-3.31-10.42-8.07-12.64-1.5-6.09-6.98-10.62-13.53-10.62-.24,0-.48.02-.71.04-1.61-3.08-4.83-5.18-8.54-5.18-1.35,0-2.63.28-3.8.78-2.97-1.78-6.42-2.82-10.13-2.82-4.45,0-8.55,1.49-11.85,3.98-1.61-1.21-3.61-1.93-5.78-1.93-4.19,0-7.74,2.67-9.08,6.4-1.23-.37-2.54-.58-3.89-.58-7.06,0-12.84,5.42-13.44,12.33-4.29,1.97-7.27,6.28-7.27,11.31,0,4.1,1.99,7.73,5.05,10-.55,1.11-.87,2.35-.87,3.67,0,4.56,3.7,8.26,8.26,8.26,3.59,0,6.63-2.29,7.77-5.49,2.59,2.1,5.89,3.37,9.48,3.37,4.18,0,7.95-1.7,10.68-4.45,2.65,3.96,7.17,6.56,12.29,6.56s9.5-2.53,12.17-6.4c2.37,2.31,5.49,3.85,8.97,4.2,1.47,1.36,3.43,2.2,5.6,2.2,4.56,0,8.26-3.7,8.26-8.26,0-.09-.01-.17-.01-.26.51-.72.95-1.5,1.33-2.31,4.24-2.39,7.11-6.93,7.11-12.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.52,103.94h0c6.27,0,11.36,5.09,11.36,11.36v2.01h-9.94c-3.18,0-5.77-2.58-5.77-5.77v-3.26c0-2.4,1.95-4.34,4.34-4.34Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 121.34,
    cy: 65.16,
    r: 14.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 121.34,
    cy: 46.29,
    r: 19.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 100.5,
    cy: 62.78,
    r: 15.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 89.27,
    cy: 58.03,
    r: 12.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 149.81,
    cy: 58.03,
    r: 12.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 98.53,
    cy: 47.89,
    r: 13.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 137.12,
    cy: 62.78,
    r: 15.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 138.81,
    cy: 47.89,
    r: 13.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 108.64,
    cy: 38.23,
    r: 9.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 129.61,
    cy: 38.23,
    r: 9.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 150.91,
    cy: 71.7,
    r: 8.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 87.03,
    cy: 71.7,
    r: 8.26
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLev1);
export default __webpack_public_path__ + "static/media/lev_1.d5d2c1d8390946abf8b0ae269578566a.svg";
export { ForwardRef as ReactComponent };